export default __webpack_public_path__ + "static/media/naidi-1-1.917643c1.svg";